// @ts-nocheck
import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { useGetLink } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button, { ButtonIcon, ButtonPresentationProps } from "@insite/mobius/Button";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Hidden from "@insite/mobius/Hidden";
import { IconPresentationProps } from "@insite/mobius/Icon";
import ArrowRight from "@insite/mobius/Icons/ArrowRight";
import LazyImage from "@insite/mobius/LazyImage";
import getColor from "@insite/mobius/utilities/getColor";
import { useHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import parse from "html-react-parser";
import * as React from "react";
import { FC } from "react";
import styled, { css } from "styled-components";

const enum fields {
    bannerImage1 = "bannerImage1",
    bannerImage2 = "bannerImage2",
    bannerImage3 = "bannerImage3",
    destination1 = "destination1",
    destination2 = "destination2",
    destination3 = "destination3",
    content1 = "content1",
    content2 = "content2",
    content3 = "content3",
    mobileContent1 = "mobileContent1",
    mobileContent2 = "mobileContent2",
    mobileContent3 = "mobileContent3",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.bannerImage1]: string;
        [fields.bannerImage2]: string;
        [fields.bannerImage3]: string;
        [fields.destination1]: LinkFieldValue;
        [fields.destination2]: LinkFieldValue;
        [fields.destination3]: LinkFieldValue;
        [fields.content1]: string;
        [fields.content2]: string;
        [fields.content3]: string;
        [fields.mobileContent1]: string;
        [fields.mobileContent2]: string;
        [fields.mobileContent3]: string;
    };
}

type Props = OwnProps;

export interface HomePageGridStyles {
    wrapper?: GridContainerProps;
    bannerImage1?: GridItemProps;
    bannerImage2?: GridItemProps;
    bannerImage3?: GridItemProps;
    mobilebannerImage1?: GridItemProps;
    mobilebannerImage2?: GridItemProps;
    mobilebannerImage3?: GridItemProps;
    iconProps?: IconPresentationProps;
    ArrowRightWrapper?: InjectableCss;
    ArrowRightWrapper2?: InjectableCss;
    ArrowRightWrapper3?: InjectableCss;
    ArrowRightButton?: ButtonPresentationProps;
    imageIcon?: InjectableCss;
}

const customcss = css`
    position: absolute;
    bottom: ${pxToRem(3)};
    right: 0;
`;

export const homePageGridStyles: HomePageGridStyles = {
    wrapper: {
        css: css`
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            position: relative;
            width: 100%;
            margin: auto;
            max-width: ${pxToRem(1415)};
        `,
    },
    bannerImage1: {
        width: 6,
        css: css`
            justify-content: flex-end;
            opacity: 0.9;
        `,
    },
    bannerImage2: {
        width: 6,
        css: css`
            position: relative;
            display: flex;
            justify-content: flex-start;
            flex-direction: column;
        `,
    },
    imageIcon: {
        css: css`
            position: relative;
        `,
    },
    mobilebannerImage1: {
        width: 12,
        css: css`
            padding: ${pxToRem(0)} !important;
        `,
    },
    mobilebannerImage2: {
        width: 12,
        css: css`
            padding: ${pxToRem(0)} !important;
        `,
    },
    mobilebannerImage3: {
        width: 12,
        css: css`
            padding: ${pxToRem(0)} !important;
        `,
    },
    iconProps: {
        size: 35,
    },
    ArrowRightWrapper: {
        css: css`
            position: absolute;
            bottom: ${pxToRem(0)};
        `,
    },
    ArrowRightWrapper2: {
        css: css`
            ${customcss}
        `,
    },
    ArrowRightWrapper3: {
        css: css`
            ${customcss}
        `,
    },
    ArrowRightButton: {
        css: css`
            background: ${getColor("primary.base")};
            border: ${pxToRem(0)};
            padding: ${pxToRem(0)};
            &:hover {
                background: ${getColor("primary.base")};
            }
            &:focus {
                outline: none;
            }
        `,
    },
};
const styles = homePageGridStyles;
const ImagesGrid: FC<Props> = ({ fields }) => {
    const history = useHistory();
    const link1 = useGetLink(fields.destination1);
    const link2 = useGetLink(fields.destination2);
    const link3 = useGetLink(fields.destination3);

    const onClickImage1 = () => {
        if (link1.url) {
            history.push(link1.url);
        }
    };
    const onClickImage2 = () => {
        if (link2.url) {
            history.push(link2.url);
        }
    };
    const onClickImage3 = () => {
        if (link3.url) {
            history.push(link3.url);
        }
    };

    return (
        <>
            <Hidden below="lg">
                <GridContainer {...styles.wrapper}>
                    <GridItem {...styles.bannerImage1}>
                        <LazyImage
                            onClick={onClickImage1}
                            src={fields.bannerImage1}
                            altText={translate("BannerImage1")}
                        ></LazyImage>
                        <ContentWrapper onClick={onClickImage1}>{parse(fields.content1, parserOptions)}</ContentWrapper>
                        <StyledWrapper {...styles.ArrowRightWrapper}>
                            <Button {...styles.ArrowRightButton}>
                                <ButtonIcon onClick={onClickImage1} {...styles.iconProps} src={ArrowRight} />
                            </Button>
                        </StyledWrapper>
                    </GridItem>
                    <GridItem {...styles.bannerImage2}>
                        <StyledWrapper>
                            <StyledWrapper {...styles.imageIcon}>
                                <LazyImage
                                    onClick={onClickImage2}
                                    src={fields.bannerImage2}
                                    altText={translate("BannerImage2")}
                                />
                                <StyledWrapper {...styles.ArrowRightWrapper2}>
                                    <Button {...styles.ArrowRightButton}>
                                        <ButtonIcon onClick={onClickImage2} {...styles.iconProps} src={ArrowRight} />
                                    </Button>
                                </StyledWrapper>
                            </StyledWrapper>
                            <ContentWrapper2 onClick={onClickImage2}>
                                {parse(fields.content2, parserOptions)}
                            </ContentWrapper2>
                        </StyledWrapper>
                        <StyledWrapper>
                            <StyledWrapper {...styles.imageIcon}>
                                <LazyImage
                                    onClick={onClickImage3}
                                    src={fields.bannerImage3}
                                    altText={translate("BannerImage3")}
                                />
                                <StyledWrapper {...styles.ArrowRightWrapper3}>
                                    <Button {...styles.ArrowRightButton}>
                                        <ButtonIcon onClick={onClickImage3} {...styles.iconProps} src={ArrowRight} />
                                    </Button>
                                </StyledWrapper>
                            </StyledWrapper>
                            <ContentWrapper3 onClick={onClickImage3}>
                                {parse(fields.content3, parserOptions)}
                            </ContentWrapper3>
                        </StyledWrapper>
                    </GridItem>
                </GridContainer>
            </Hidden>
            <Hidden above="md">
                <GridContainer {...styles.wrapper}>
                    <GridItem {...styles.mobilebannerImage1}>
                        <LazyImage
                            onClick={onClickImage1}
                            src={fields.bannerImage1}
                            altText={translate("BannerImage1")}
                        ></LazyImage>
                        <ContentWrapperMobile1 onClick={onClickImage1}>
                            {parse(fields.mobileContent1, parserOptions)}
                        </ContentWrapperMobile1>
                    </GridItem>
                    <GridItem {...styles.mobilebannerImage2}>
                        <LazyImage
                            onClick={onClickImage2}
                            src={fields.bannerImage2}
                            altText={translate("BannerImage2")}
                        />
                        <ContentWrapperMobile2 onClick={onClickImage2}>
                            {parse(fields.mobileContent2, parserOptions)}
                        </ContentWrapperMobile2>
                    </GridItem>
                    <GridItem {...styles.mobilebannerImage3}>
                        <LazyImage
                            onClick={onClickImage3}
                            src={fields.bannerImage3}
                            altText={translate("BannerImage3")}
                        />
                        <ContentWrapperMobile2 onClick={onClickImage3}>
                            {parse(fields.mobileContent3, parserOptions)}
                        </ContentWrapperMobile2>
                    </GridItem>
                </GridContainer>
            </Hidden>
        </>
    );
};

const image1Tab = {
    displayName: "Image1",
    sortOrder: 0,
};

const image2Tab = {
    displayName: "Image2",
    sortOrder: 1,
};
const image3Tab = {
    displayName: "Image3",
    sortOrder: 2,
};
const widgetModule: WidgetModule = {
    component: ImagesGrid,
    definition: {
        icon: "objects-column",
        group: "Basic",
        fieldDefinitions: [
            {
                name: fields.bannerImage1,
                displayName: "Banner Image",
                editorTemplate: "ImagePickerField",
                defaultValue: "",
                fieldType: "Translatable",
                tab: image1Tab,
            },
            {
                name: fields.destination1,
                editorTemplate: "LinkField",
                defaultValue: { type: "Page", value: "" },
                fieldType: "General",
                tab: image1Tab,
            },
            {
                name: fields.bannerImage2,
                displayName: "Banner Image2",
                editorTemplate: "ImagePickerField",
                defaultValue: "",
                fieldType: "Translatable",
                tab: image2Tab,
            },
            {
                name: fields.destination2,
                editorTemplate: "LinkField",
                defaultValue: { type: "Page", value: "" },
                fieldType: "General",
                tab: image2Tab,
            },
            {
                name: fields.bannerImage3,
                displayName: "Banner Image3",
                editorTemplate: "ImagePickerField",
                defaultValue: "",
                fieldType: "Translatable",
                tab: image3Tab,
            },
            {
                name: fields.destination3,
                editorTemplate: "LinkField",
                defaultValue: { type: "Page", value: "" },
                fieldType: "General",
                tab: image3Tab,
            },
            {
                name: fields.content1,
                displayName: "Content",
                editorTemplate: "RichTextField",
                defaultValue: "",
                fieldType: "Contextual",
                tab: image1Tab,
            },
            {
                name: fields.content2,
                displayName: "Content",
                editorTemplate: "RichTextField",
                defaultValue: "",
                fieldType: "Contextual",
                tab: image2Tab,
            },
            {
                name: fields.content3,
                displayName: "Content",
                editorTemplate: "RichTextField",
                defaultValue: "",
                fieldType: "Contextual",
                tab: image3Tab,
            },
            {
                name: fields.mobileContent1,
                displayName: "MobileContent",
                editorTemplate: "RichTextField",
                defaultValue: "",
                fieldType: "Contextual",
                tab: image1Tab,
            },
            {
                name: fields.mobileContent2,
                displayName: "Content",
                editorTemplate: "RichTextField",
                defaultValue: "",
                fieldType: "Contextual",
                tab: image2Tab,
            },
            {
                name: fields.mobileContent3,
                displayName: "Content",
                editorTemplate: "RichTextField",
                defaultValue: "",
                fieldType: "Contextual",
                tab: image3Tab,
            },
        ],
    },
};

export default widgetModule;

const customcssWrapper = css`
    position: absolute;
    opacity: 1;
    color: white;
    p {
        margin-bottom: 0 !important;
    }
`;

const ContentWrapper = styled.div`
    ${customcssWrapper}
    top: 50%;
    right: 70%;
`;

const ContentWrapper2 = styled.div`
    ${customcssWrapper}
    top: 20%;
    padding: 10px;
`;

const ContentWrapper3 = styled.div`
    ${customcssWrapper}
    top: 69%;
    padding: 10px;
`;

const ContentWrapperMobile1 = styled.div`
    ${customcssWrapper}
    top: 20%;
    padding: 33px;
`;
const ContentWrapperMobile2 = styled.div`
    ${customcssWrapper}
    padding: 33px;
`;
